import { useState } from "react";
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Textarea,
} from "../ui";
import { FormLabel } from "@/components";
import { Loader } from "../Loader";
import { toast } from "@/components/Toast";
import { cn } from "@/lib/utils";
import { X } from "lucide-react";

const ApproveRejectBudgetDialog = ({
  open,
  onClose,
  onConfirm,
  isLoading,
  isApproved,
}: any) => {
  const [reason, setReason] = useState("");

  const onSubmit = () => {
    if (reason.trim()?.length < 5) {
      toast.error("Please enter a reason with at least 5 characters");
      return;
    }
    setReason("");
    onConfirm(reason);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="max-w-screen-2xl p-6 rounded-2xl shadow-xl"
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center justify-between">
            <DialogTitle className="text-2xl font-bold text-primary">
              {isApproved ? "Reason for Approval" : "Reason for Rejection"}
              <div className="h-1 w-[60%] bg-primary rounded-full" />
            </DialogTitle>
            <DialogClose asChild>
              <Button
                type="button"
                variant="ghost"
                // onClick={onCloseClick}
                className="rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none"
              >
                <X className="h-5 w-5 stroke-[5px]" />
              </Button>
            </DialogClose>
          </div>
        </DialogHeader>

        <DialogDescription className="text-gray-600 mt-2">
          Are you sure you want to {isApproved ? "approve" : "reject"} this budget? Please provide a reason
          for {isApproved ? "approval" : "rejection"} before proceeding.
          <div className="relative flex flex-col items-start gap-1 mt-5">
            <FormLabel>
              Description<span className="text-red-700">*</span>
            </FormLabel>
            <Textarea
              onChange={(e) => setReason(e.target.value)}
              value={reason}
              rows={10}
              placeholder="Please enter"
            />
          </div>
        </DialogDescription>

        <div className="flex justify-end gap-4 mt-6">
          <Button
            variant="default"
            className={cn(
              isApproved
                ? "bg-green-600 hover:bg-green-600"
                : "bg-red-600 hover:bg-red-600"
            )}
            onClick={onSubmit}
            disabled={isLoading}
          >
            {isLoading && <Loader variant="secondary" />}{" "}
            {isApproved ? "Approve" : "Reject"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ApproveRejectBudgetDialog;
